/**
 * Knowledge Base Service Hooks
 */
import { useCCMS } from '../useCCMS';
export function useKnowledgeBaseServices() {
    const { services } = useCCMS();
    if (!services?.knowledgeBase) {
        throw new Error('Knowledge Base services not available. Ensure CCMSProvider is configured with knowledgeBase services.');
    }
    return services.knowledgeBase;
}
export function useKnowledgeBaseService() {
    return useKnowledgeBaseServices().knowledgeBase;
}
export function useKBCategoryService() {
    return useKnowledgeBaseServices().category;
}
export function useKBArticleService() {
    return useKnowledgeBaseServices().article;
}
export function useKBStepService() {
    return useKnowledgeBaseServices().step;
}
export function useKnowledgeBaseStatusService() {
    return useKnowledgeBaseServices().status;
}
export function useKBCategoryStatusService() {
    return useKnowledgeBaseServices().categoryStatus;
}
export function useKBArticleStatusService() {
    return useKnowledgeBaseServices().articleStatus;
}
export function useKBStepTypeService() {
    return useKnowledgeBaseServices().stepType;
}
/**
 * KB visibility lookup (Public / Unlisted / Restricted). Feeds the picker in
 * the admin VisibilityAudienceEditor; mirrors the Course visibility flow.
 */
export function useKBVisibilityService() {
    return useKnowledgeBaseServices().visibility;
}
/** AI-assisted KB search (Stage 6). Lives on CCMS.Api.AIManagement. */
export function useKnowledgeBaseQAService() {
    return useKnowledgeBaseServices().qa;
}
/**
 * Anonymous-capable public Knowledge Base surface. Visibility + audience
 * (role / ministry / department) are enforced server-side, so this is what
 * the Resource Centre should hit instead of the admin-tier KB services.
 */
export function usePublicKnowledgeBaseService() {
    return useKnowledgeBaseServices().public;
}
//# sourceMappingURL=useKnowledgeBaseServices.js.map